// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"6920f8bd","71":"5e72be62","107":"8b1971b8","141":"1f6a4b91","296":"70af2727","405":"15881659","507":"f967d75a","560":"a0103bfb","698":"cbfcc70a","722":"90f615d9","883":"bea63724","923":"c28c5c50","962":"dbaf8d80"}[chunkId] + ".chunk.js";
};